<template>
  <PageTemplate v-if="isAuthenticated()">
    <h1>Resources And Forms</h1>
    <div>
      <v-card title="Resources, Training Material, User guides and more">
        <v-table
          :table="table"
          @showDoc="previewDoc"
          @downloadDoc="downloadDoc"
        />
      </v-card>
    </div>
  </PageTemplate>
</template>
<script>
  import PageTemplate from "../templates/Page/index.vue";
  import Card from "@/molecules/Card";
  import Table from "@/molecules/Table";
  import {
    DOWNLOAD_PUBLICATION,
    PREVIEW_PUBLICATION,
    DOWNLOAD_BULK_PUBLICATION
  } from "../store/actions.type";

  import {columnFilter, columnSort, dateSort_ddmmyyyy} from "@/common/tableFunctions";
  import {buildBreadCrumb} from "@/common/tableFunctions";
  import routes from "@/common/routes";
  import TokenService from "@/common/tokenService";

  export default {
    name: "ArResourcesForms",
    components: {
      "v-table": Table,
      "v-card": Card,
      PageTemplate,
    },
    data() {
      return {
        table: {
          columns: [
          {
              label: 'Type',
              field: 'typeIcon',
              sortable: false,
              actions: 'icon_only',
              thClass: 'shrink-cell',
              tdClass: 'no-wrap',
            },
            {
              label: 'Name',
              field: 'name',
              sortFn: columnSort,
              thClass: 'sortable',
              filterOptions: {
                enabled: true,
                placeholder: 'Search',
                filterFn: columnFilter
              },
            },
            {
              label: 'Date Updated',
              field: 'dateUpdated',
              sortFn: dateSort_ddmmyyyy,
              thClass: 'sortable',
              filterOptions: {
                enabled: true,
                placeholder: 'Date',
                filterFn: columnFilter
              },
            },
            {
              label: 'Actions',
              field: 'actions',
              sortable: false,
              actions: 'view',
              thClass: 'shrink-cell',
              tdClass: 'no-wrap',
            },
          ],
          rows: [],
          totalRecords: 0
        }
      };
    },
    computed: {
    },
    mounted() {
      this.updateBreadCrumb();
      this.getRecentUpdates();
    },
    methods: {
      isAuthenticated() {
        return !!TokenService.getToken();
      },
      downloadSelected: function (params) {
        let res = this.documents.filter(ele => ele.isSelected).map(ele => ele.id);
        this.$store.state.auth.isLoading = true;
        this.$store.dispatch(DOWNLOAD_BULK_PUBLICATION, res).then(res => {
          this.$notify({
              title: 'Success',
              text: res.message,
              type: 'success'
            });
        }).catch(err => {
          this.$notify({
                title: 'Error',
                text: err.message,
                type: 'error'
              });
        }).finally(() => {
          this.selectAllAction({target: {checked:false}});
            this.$store.state.auth.isLoading = false;
          });
      },
      downloadDoc: function (params) {
        let id = params;
        this.$store.state.auth.isLoading = true;
        this.$store.dispatch(DOWNLOAD_PUBLICATION, {id})
          .then(response => {
            return response;
          }).finally(() => {
            this.$store.state.auth.isLoading = false;
          });
      },
      previewDoc(params) {
          window.open(params, '_blank');
      },
      updateBreadCrumb: function () {
        let breadcrumbs = [];
        breadcrumbs['Dashboard'] = routes.DASHBOARD;
        breadcrumbs['Resources And Forms'] = '';
        this.$store.dispatch('updateBreadCrumbAction', buildBreadCrumb(breadcrumbs));
      },
      getRecentUpdates() {
        let transformed = [];
        let usefulResources = [];
        try {
          fetch(process.env.VUE_APP_AR_USEFUL_RESOURCES+'?ts='+Date.now())
          .then(response => response.text())
          .then(text => {
            usefulResources = JSON.parse(text);
            transformed = usefulResources.map(ur => {
              return {
                'name': {"value": ur.name},
                'dateUpdated': {"value": ur.dateUpdated},
                'actions': [{"link": ur.url}],
                'typeIcon': ur.typeIcon
              }
            });
            this.table.rows = transformed;
            }).catch(e => {
              this.$notify({
                title: 'Error',
                text: e,
                type: 'error'
              });
          });
        }catch(e) {
            this.$notify({
              title: 'Error',
              text: e,
              type: 'error'
            });
        }
      }
    }
  }
</script>

